import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createFlagUpdatesChangeExtension } from '@spotify/plugin-confidence-flags-react';

const STATE_LABELS: Record<string, string> = {
  UNALLOCATED: 'Unallocated',
  ALLOCATED: 'Allocated',
  OK: 'OK',
  ARCHIVED: 'Archived',
};

const getStateLabel = (value: unknown): string => {
  if (typeof value === 'string') {
    return STATE_LABELS[value] ?? value;
  }
  return 'Unknown';
};

const getActionTitle = (newState: unknown): string => {
  if (newState === 'ARCHIVED') {
    return 'Archived';
  }
  return 'Updated state';
};

const StateChangeRender = ({ change }: ActivityChangeOptions) => (
  <ActivityItem.Section label="Updated state">
    <ActivityTagItem
      oldValue={getStateLabel(change.oldValue)}
      newValue={getStateLabel(change.newValue)}
    />
  </ActivityItem.Section>
);

export const SEGMENT_STATE_CHANGE_EXTENSION = createFlagUpdatesChangeExtension({
  id: 'segment-state-change',
  priority: 10,
  predicate: ({ change }) => change.fieldPath === '/state',
  title: change => getActionTitle(change.newValue),
  render: StateChangeRender,
  values: change => ({
    oldValue: { state: change.oldValue },
    newValue: { state: change.newValue },
  }),
});
